import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "field col" }
const _hoisted_2 = { class: "field col" }
const _hoisted_3 = { class: "flex flex-row p-2 w-full m-0 transfer__items" }
const _hoisted_4 = { class: "flex flex-row w-full m-0 pl-2 org__items" }
const _hoisted_5 = { class: "flex flex-row mt-4 align-content-center" }

import { ref, toRefs, onMounted, computed } from 'vue';
import Dialog from 'primevue/dialog';
import Panel from 'primevue/panel';
import { useToast } from 'primevue/usetoast';
import TreeSelect from 'primevue/treeselect';
import { EMIT } from '@/enum';
import { OrganizationInterface, StudentTableInterface } from '@/types';
import { useOrganizationStore } from '@/store';
import Icon from '@/components/Icon';

interface TransferOrgPropsInterface {
  students: StudentTableInterface[] | [];
  organization: OrganizationInterface;
}

interface TransferOrgPayloadInterface {
  students: number[] | [];
  organization: OrganizationInterface;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TransferModal',
  props: {
    students: {},
    organization: {}
  },
  setup(__props: any, { emit: __emit }) {

const toast = useToast();
const organizationStoreParents = useOrganizationStore();
const organizationStore = useOrganizationStore();

const props = __props;
const emit = __emit;

const { students, organization } = toRefs(props);
const studentNames = computed(() => {
  return students.value
    .map((student) => {
      return student.name;
    })
    .join(', ');
});
const organizations = ref();
const idSelectedOrganization = ref();
const selectedOrganization = ref<OrganizationInterface>();
const modalVisible = ref(true);

onMounted(async () => {
  await organizationStore.getOrganizations();
  await organizationStoreParents.getParentsOrganizations();
  organizations.value = organizationStore.organizations.data
    .map((org) => org.data)
    .filter((org) => org.id !== organization.value.id);
});

const selectOrganization = async () => {
  const organizationId = Number(Object.keys(idSelectedOrganization.value)[0]);
  selectedOrganization.value = await organizationStore.getOrganizationInfo(organizationId);
  if (selectedOrganization.value.id === organizationStore.organization.id) {
    toast.add({
      severity: 'warn',
      summary: 'Not selectable',
      detail: 'Cannot be transferred to the same organization',
      life: 3000,
    });
    selectedOrganization.value = {} as OrganizationInterface;
    idSelectedOrganization.value = {};
  }
};

const transferOrg = (): void => {
  emit(EMIT.TRANSFER, {
    students: students.value.map((student) => student.id),
    organization: selectedOrganization.value as OrganizationInterface,
  });
  selectedOrganization.value = undefined;
  modalVisible.value = false;
};

const cancel = (): void => {
  emit(EMIT.CANCEL);
  selectedOrganization.value = undefined;
  modalVisible.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: modalVisible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((modalVisible).value = $event)),
    header: "Transfer to new organization",
    draggable: false,
    modal: true,
    class: "dialog__container transfer__modal",
    onHide: cancel
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_AppButton, {
        text: "Cancel",
        type: "secondary",
        onClick: cancel
      }),
      _createVNode(_component_AppButton, {
        disabled: !selectedOrganization.value,
        text: "Transfer Student(s)",
        type: "primary",
        onClick: transferOrg
      }, null, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("label", {
          class: "required",
          for: "type"
        }, "Organization", -1)),
        _createVNode(_unref(TreeSelect), {
          id: "organization_type_id",
          modelValue: idSelectedOrganization.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((idSelectedOrganization).value = $event)),
          options: _unref(organizationStoreParents).organizationParents,
          "option-label": "name",
          "selection-mode": "single",
          "option-value": "id",
          loading: _unref(organizationStoreParents).loading,
          placeholder: "Select Organization",
          style: {"font-weight":"bold"},
          class: "w-full",
          onChange: selectOrganization
        }, null, 8, ["modelValue", "options", "loading"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Panel), { class: "preview__container" }, {
          header: _withCtx(() => [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex flex-column p-2 w-full preview__text" }, "Preview", -1)),
            _createElementVNode("div", _hoisted_3, _toDisplayString(studentNames.value), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createTextVNode(_toDisplayString(_unref(organization).name) + " ", 1),
              _createVNode(_unref(Icon), {
                class: "pl-3 pr-3",
                name: "arrow_forward"
              }),
              _createElementVNode("span", {
                class: _normalizeClass(["selected__org", { selected: selectedOrganization.value }])
              }, _toDisplayString(selectedOrganization.value?.name || 'New Organization'), 3)
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(Icon), {
            name: "warning",
            class: "md-12 warning__text__icon mr-1"
          }),
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "warning__text__span text-xs" }, " Any connections to users that do not belong to the new organization will be removed. ", -1))
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})